
import modelGenerator from "../helpers/modelGenerator"

const schema = {
	name: "ItemCategory",
	label: "Item Category",
	plural: "Item Categories",
	fields: {
		id: {
			changeable: false
		},
		title: {
			type: "text",
			label: "Item Category",
			maxLength: 50,
			rules: [
	          v => !!v || 'Item Category is required',
	          v => v && v.length >= 3 || 'Must be more than 2 characters',
	          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
	        ]
		},
		description: {
			type: "textarea",
			label: "Description",
			maxLength: 250,
			rules: []
		},
        is_deleted: {
			changeable: false,
			default: false
		}
	}
}

modelGenerator.generate(schema)

export default schema
